export default {
  Subs: {
    For: "Suscripción a",
    PTM:
      "la Plataforma para médicos «" + process.env.VUE_APP_INSTALL_NAME + "»",
    BySub: "Por suscripción",
    Free: "Gratis",
    CostDesc: "en <period> por usuario",
    month: "mes",
    day: "día",
    year: "año",
    Connect: "Conectar",
    Connectv2: "Activar suscripción",
    CorpPlan: {
      desc: "Individual",
      feature_1: "Programas personalizados",
      feature_2:
        "Procesamiento de una cantidad seleccionada de estudios al mes con cualquier IA",
      cost: "A consultar",
      request: "Enviar solicitud",
      requested: "¡Su solicitud fue enviada exitosamente!",
      requested2:
        "Nos pondremos en contacto con usted pronto para discutir los detalles y ofrecerle la mejor solución. Si tiene preguntas, <a target='_blank' class='demo__underline' href='https://t.me/thirdopinion_support_bot'>¡escríbanos!</a>",
    },
    yourSub: "Tu suscripción",
    PlansDesc: "Descripción detallada de los planes",
    Offer: "Oferta",
    EnterPromo: "Ingrese un código promocional",
    Errors: {
      NotPurchase: "No se pudo activar la suscripción, intente más tarde",
    },
    DiffSubs: "Diferencias entre planes",
    Plan: "Plan",
    Unavailable: "Primero debe cancelar la suscripción actual",
    extSub: "Seleccionar plan avanzado",
    lets: {
      modalTitle: {
        base: "Ingrese su",
        and: " y ",
        phone: " número de teléfono",
        email: "correo electrónico",
      },
      text: "Para activar la suscripción debe ingresar su<PHONE><EMAIL>. Esto permitirá enviarle notificaciones del estado de su suscripción, confirmaciones de operaciones y otros mensajes importantes.",
      formInvalid: "Formulario incompleto o incorrecto",
    },
    cancelSub: "Cancelar",
    unsub: {
      title: "Ya no tendrá acceso a:",
      modalTitle: "¿Está seguro de que desea cancelar la suscripción?",
      modalTitle2: "Seleccione el motivo de cancelación",
      cancel: "Suscripción <NAME> reanudada. El próximo pago será el <DATE>",
      yes: "Cancelar suscripción",
      no: "Mantener suscripción",
      thx: {
        title: "¡Gracias por seguir con nosotros!",
        continue: "Continuar",
      },
      reasons: {
        0: "El precio no me conviene",
        1: "No uso el servicio",
        2: "La interfaz no es cómoda",
        3: "Otro",
      },
      complete: {
        title: "Has cancelado tu suscripción",
        text1: "Tu suscripción permanecerá activa hasta ",
        text2:
          ", podrás seguir usando el servicio hasta entonces. ¡Esperamos verte de nuevo!",
        recover: "Reactivar suscripción",
      },
    },
    backToSite: "Volver al sitio",
    afterPay: {
      title: "¡Tu suscripción ha sido activada con éxito!",
      text: "¡Ahora tienes acceso a todas las funciones del servicio!",
      buttonText: "Comenzar",
    },
  },
};
